import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/house.svg'
import _imports_1 from '../../../assets/images/property-sample-image.jpg'
import _imports_2 from '../../../assets/icons/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-3f6f6a6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_issue_preview" }
const _hoisted_2 = { class: "left_block" }
const _hoisted_3 = { class: "issue_type__overview_card_content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Issue Overview")
], -1))
const _hoisted_5 = { class: "issue_type__overview_card_text" }
const _hoisted_6 = { class: "issue_type__overview_card_text_item" }
const _hoisted_7 = { class: "issue_type__overview_list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address", -1))
const _hoisted_9 = {
  key: 0,
  class: "property_address"
}
const _hoisted_10 = { class: "issue_type__overview_card_text_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Issue Details", -1))
const _hoisted_12 = { class: "issue_type__overview_list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Issue Type", -1))
const _hoisted_14 = {
  key: 0,
  class: "yellow-content-box"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "SLA Time (Manual Intervention)", -1))
const _hoisted_16 = { class: "right_block" }
const _hoisted_17 = { class: "top_links_main" }
const _hoisted_18 = { class: "back_results" }
const _hoisted_19 = { class: "emergency" }
const _hoisted_20 = { class: "issue_info__wrapper" }
const _hoisted_21 = { class: "card_content" }
const _hoisted_22 = { class: "card_content__header" }
const _hoisted_23 = { class: "card_content__title" }
const _hoisted_24 = { class: "card_content__footer" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Issue Notes", -1))
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Issue Title")
], -1))
const _hoisted_28 = { class: "description" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Issue Notes", -1))
const _hoisted_30 = { class: "custom_editor" }
const _hoisted_31 = { class: "edit__buttons" }
const _hoisted_32 = { class: "specialism__wrapper" }
const _hoisted_33 = { class: "header" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Services")
], -1))
const _hoisted_35 = { class: "specialism__wrapper__content" }
const _hoisted_36 = { class: "specialism-card-list" }
const _hoisted_37 = { class: "specialism-card-list__item-author" }
const _hoisted_38 = { class: "specialism-card-list__item-author-image" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "specialism-card-list__item-author-content" }
const _hoisted_41 = {
  key: 0,
  class: "edit-mode-button"
}
const _hoisted_42 = { class: "edit__buttons" }
const _hoisted_43 = { class: "properties_wrapper" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Properties")
  ])
], -1))
const _hoisted_45 = { class: "properties_wrapper__content" }
const _hoisted_46 = { class: "properties_wrapper__left" }
const _hoisted_47 = { class: "properties_wrapper__info__left" }
const _hoisted_48 = { class: "location" }
const _hoisted_49 = { class: "prop_name" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_51 = { class: "property_type" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "properties_wrapper__info__right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "property_image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_53 = { class: "properties_wrapper__right" }
const _hoisted_54 = {
  key: 0,
  class: "map__wrapper",
  id: "map_properties"
}
const _hoisted_55 = { class: "title" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Documents / Attachments", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_58 = {
  key: 0,
  class: "group__cards"
}
const _hoisted_59 = { class: "group__card__text" }
const _hoisted_60 = { class: "accordion_inner_title" }
const _hoisted_61 = { class: "doc_main" }
const _hoisted_62 = { class: "doc_main__list" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 0,
  class: "close_icon"
}
const _hoisted_65 = {
  key: 0,
  class: "property__images"
}
const _hoisted_66 = ["src", "alt", "onClick"]
const _hoisted_67 = {
  key: 1,
  class: "edit-mode-button"
}
const _hoisted_68 = { class: "edit__buttons" }
const _hoisted_69 = { class: "modal__content" }
const _hoisted_70 = { class: "left_upload_img" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Upload images and files.", -1))
const _hoisted_72 = { class: "upload__area" }
const _hoisted_73 = { class: "uploade-wrapper" }
const _hoisted_74 = {
  key: 0,
  class: "error_msg"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Drag and drop documents, or"),
    /*#__PURE__*/_createElementVNode("span", null, "Browse")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ")
], -1))
const _hoisted_76 = { class: "selected-info" }
const _hoisted_77 = { class: "image__upload__wrapper" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uploaded Files", -1))
const _hoisted_80 = { class: "uploaded_details_wrapper" }
const _hoisted_81 = { class: "prop_img_details" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_83 = { class: "upload__list" }
const _hoisted_84 = {
  key: 1,
  class: "blank_project"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your added project attachments will show up here", -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { class: "footer__button footer-buttons" }
const _hoisted_88 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PropertyMapModal = _resolveComponent("PropertyMapModal")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_commonDialog = _resolveComponent("commonDialog")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_SpecialismMultiSelectModel = _resolveComponent("SpecialismMultiSelectModel")!
  const _component_ManualIntervention = _resolveComponent("ManualIntervention")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_card, { class: "issue_type__overview_card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    ($setup.issuesReviewComponent?.property?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.issuesReviewComponent?.property, (property) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: property.id
                            }, _toDisplayString(property?.property?.address), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", null, _toDisplayString($setup.issuesReviewComponent.issueType), 1)
                  ])
                ])
              ])
            ]),
            ($setup.issuesReviewComponent.issueStatus === $setup.PropertyIssueStatus.DRAFT)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "button button-orange",
                  size: "large",
                  block: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickSaveIssueLater($setup.PropertyIssueStatus.RAISED))),
                  loading: $setup.isShowLoaderOnRaiseAnIssue,
                  disabled: 
            $setup.isShowLoaderOnSaveIssueForLater ||
            $setup.isShowLoaderOnRaiseAnIssue ||
            $setup.isShowLoaderOnDeleteIssue
          
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" raise issue ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true),
            ($setup.issuesReviewComponent.issueStatus === $setup.PropertyIssueStatus.DRAFT)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  class: "button button-purple-border",
                  size: "large",
                  block: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickSaveIssueLater($setup.PropertyIssueStatus.DRAFT))),
                  loading: $setup.isShowLoaderOnSaveIssueForLater,
                  disabled: 
            $setup.isShowLoaderOnSaveIssueForLater ||
            $setup.isShowLoaderOnRaiseAnIssue ||
            $setup.isShowLoaderOnDeleteIssue
          
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" save Issue for later ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true),
            ($props.isShowDeleteButton)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  class: "button button-red",
                  size: "large",
                  block: "",
                  variant: "outlined",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickDelete())),
                  loading: $setup.isShowLoaderOnDeleteIssue,
                  disabled: 
            $setup.isShowLoaderOnSaveIssueForLater ||
            $setup.isShowLoaderOnRaiseAnIssue ||
            $setup.isShowLoaderOnDeleteIssue
          
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Delete ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (
          $setup.issuesReviewComponent.issueType ===
          $setup.PropertyIssueType.EMERGENCY_OUT_OF_HOURS
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_v_btn, {
                class: "button button-orange",
                onClick: $setup.onClickManualInterventionButton
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Yes")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_v_btn, {
              "prepend-icon": "mdi-chevron-left",
              variant: "plain",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onClickBackButton()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_icon, { icon: "mdi mdi-alert-circle" }),
            _createElementVNode("p", null, _toDisplayString($setup.issuesReviewComponent.issueType), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (!$setup.isEditIssueNoteSection)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "issue_info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("h5", null, _toDisplayString($setup.issuesReviewComponent.title), 1)
                      ]),
                      _createVNode(_component_v_icon, {
                        class: "custom_edit",
                        icon: "mdi-pencil",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.updateIssueNameNote()), ["stop"]))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("p", {
                        innerHTML: $setup.issuesReviewComponent.description
                      }, null, 8, _hoisted_26)
                    ])
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                class: "edit_issue_info"
              }, {
                default: _withCtx(() => [
                  _hoisted_27,
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    placeholder: "Enter Title",
                    modelValue: $setup.issueDetails.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.issueDetails.name) = $event)),
                    variant: "outlined",
                    class: "property_input"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_quill_editor, {
                        value: $setup.issueDetails.description,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.issueDetails.description) = $event)),
                        options: $setup.state.editorOption,
                        disabled: $setup.state.disabled,
                        class: "editor_ql"
                      }, null, 8, ["value", "options", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_v_btn, {
                      class: "button button-white",
                      onClick: $setup.onCancelIssueNotes,
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" cancel ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      variant: "accent",
                      label: $setup.isLoadingIssueNotes ? 'SAVE' : 'save',
                      onClick: $setup.onClickSaveIssueNotes,
                      class: "button",
                      isLoading: $setup.isLoadingIssueNotes,
                      "prepend-icon": "mdi-content-save"
                    }, null, 8, ["label", "onClick", "isLoading"])
                  ])
                ]),
                _: 1
              }))
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            (!$setup.isEditSpecialism)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  class: "custom_edit",
                  icon: "mdi-pencil",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.isEditSpecialism = true))
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.issueSubCategory, (subCategory) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "specialism-card-list__item",
                  key: subCategory.id
                }, [
                  ($setup.isEditSpecialism)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "text",
                        "aria-label": "Delete",
                        class: "specialism-card-list__item-delete",
                        "prepend-icon": "mdi-delete",
                        onClick: ($event: any) => ($setup.onClickDeleteSpecialism(subCategory.id))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("img", {
                        src: 
                      require('@/assets/category-icons/' +
                        subCategory.category.iconName +
                        '.svg')
                    ,
                        alt: "Image"
                      }, null, 8, _hoisted_39)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("h2", null, _toDisplayString(subCategory.label), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          ($setup.isEditSpecialism)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  variant: "text",
                  onClick: $setup.addMoreSpecialismClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add more Services ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_v_btn, {
                    class: "button button-white",
                    variant: "outlined",
                    onClick: $setup.onclickCancelEditSpecialism
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" cancel ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    loading: $setup.isServicesSaveLoading,
                    class: "button button-orange",
                    onClick: $setup.onClickSaveSpecialism
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" save ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.issuesReviewComponent.property, (property) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "properties_wrapper__info",
                  key: property.id
                }, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi mdi-map-marker",
                        class: "pointer_events_none"
                      }),
                      _createTextVNode(" " + _toDisplayString(property?.property?.postcode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _hoisted_50
                        ]),
                        _: 1
                      }),
                      _createElementVNode("h6", null, _toDisplayString(property?.property?.address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi mdi-account-circle",
                        class: "pointer_events_none"
                      }),
                      _createTextVNode(_toDisplayString(property?.property?.propertyCategory), 1)
                    ])
                  ]),
                  _hoisted_52
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_53, [
              ($setup.addresses && $setup.addresses.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createVNode(_component_PropertyMapModal, {
                      properties: $setup.addresses,
                      className: "tw-w-full tw-h-[186px] rmd:tw-h-[380px] tw-rounded-[10px] tw-overflow-hidden"
                    }, null, 8, ["properties"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["documents_attachment", {
          'is-empty': !Object.keys($setup.issuesReviewComponent.categoryAttachments)
            .length,
        }])
        }, [
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            (Object.keys($setup.issuesReviewComponent.categoryAttachments).length)
              ? (_openBlock(), _createBlock(_component_v_select, {
                  key: 0,
                  modelValue: $setup.categoryId,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.categoryId) = $event)),
                  label: "Select property",
                  items: $setup.categoryName,
                  multiple: "",
                  variant: "outlined",
                  density: "compact",
                  class: "select_prop_dropdown",
                  "menu-props": { contentClass: 'custom__text__selector' }
                }, null, 8, ["modelValue", "items"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_expansion_panels, {
            modelValue: $setup.categoryPanel,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.categoryPanel) = $event)),
            multiple: "",
            class: "accordion__wrapper"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.issuesReviewComponent.categoryAttachments, (categoryValue, categoryKey, index) => {
                return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, null, {
                      actions: _withCtx(({ expanded }) => [
                        (expanded && !$setup.isEditAttachmentsSection)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              class: "custom_edit",
                              icon: "mdi-pencil",
                              onClick: ($event: any) => ($setup.updateAttachmentsSection(index))
                            }, null, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              icon: "mdi-chevron-down",
                              class: "bottom__chevron",
                              onClick: ($event: any) => ($setup.removeAttachmentsSection(index))
                            }, null, 8, ["onClick"]))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "house__icon" }, {
                          default: _withCtx(() => [
                            _hoisted_57
                          ]),
                          _: 1
                        }),
                        _createElementVNode("h6", null, _toDisplayString(categoryKey), 1)
                      ]),
                      _: 2
                    }, 1024),
                    ($setup.isShowGroupCard(index))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("ul", _hoisted_62, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryValue, (attachment, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          class: "property__img__name",
                                          key: index
                                        }, [
                                          _createElementVNode("div", {
                                            onClick: ($event: any) => ($setup.onClickOpenNewTab(attachment))
                                          }, [
                                            _createVNode(_component_v_icon, { icon: "mdi mdi-image-outline" }),
                                            _createElementVNode("span", null, _toDisplayString(attachment.propertyIssueAttachment?.originalName), 1)
                                          ], 8, _hoisted_63),
                                          ($setup.isEditAttachmentsSection)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                _createVNode(_component_v_icon, {
                                                  icon: "mdi-close",
                                                  class: "pointer_events_none",
                                                  onClick: ($event: any) => (
                                $setup.removeAttachmentsSection(
                                  index,
                                  attachment.propertyIssueAttachment?.id,
                                  attachment.name
                                )
                              )
                                                }, null, 8, ["onClick"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                (!$setup.isEditAttachmentsSection)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryValue, (attachment, index) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                                          class: "property__item__images",
                                          key: index
                                        }, [
                                          _createElementVNode("img", {
                                            src: attachment.propertyIssueAttachment.publicUrl,
                                            alt: attachment.propertyIssueAttachment?.originalName,
                                            onClick: ($event: any) => (
                          $setup.openCarousel(
                            index,
                            attachment?.propertyIssueAttachment?.publicUrl
                          )
                        )
                                          }, null, 8, _hoisted_66)
                                        ])), [
                                          [_vShow, $setup.isShowImage(attachment)]
                                        ])
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                ($setup.isEditAttachmentsSection)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      _createVNode(_component_v_btn, {
                                        class: "button button-purple-border",
                                        onClick: $setup.onClickToggleAttachmentModal
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Upload More ")
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createElementVNode("div", _hoisted_68, [
                                        _createVNode(_component_v_btn, {
                                          class: "button button-white",
                                          variant: "outlined",
                                          onClick: $setup.onCancelAttachments
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" cancel ")
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_v_btn, {
                                          class: "button button-orange",
                                          size: "large",
                                          block: "",
                                          loading: $setup.isLoadingRemoveAttachments,
                                          onClick: $setup.onClickSaveButtonAttachments
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" save ")
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "onClick"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", null, [
            (
              !Object.keys($setup.issuesReviewComponent.categoryAttachments).length
            )
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "button button-purple-border tw-mt-5",
                  onClick: $setup.onClickToggleAttachmentModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Upload Attachments ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _createVNode(_component_commonDialog, {
        modelValue: $setup.isShowAttachmentModal,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.isShowAttachmentModal) = $event)),
        isShowHeader: false,
        isShowBackButton: false,
        width: "860px",
        "max-width": "100%",
        persistent: "",
        className: ['issue__upload__modal']
      }, {
        body: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            class: "close__icon",
            onClick: $setup.onClickToggleAttachmentModal
          }, null, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_component_v_file_input, {
                    class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                    variant: "solo-filled",
                    modelValue: $setup.selectedFile,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.selectedFile) = $event)),
                    onChange: $setup.onFileChange,
                    "onClick:clear": $setup.clearImageUrl,
                    multiple: ""
                  }, {
                    "append-inner": _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-image-plus")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "class", "onChange", "onClick:clear"]),
                  _createVNode(_component_v_img, {
                    class: "uploaded-img",
                    width: 200,
                    "aspect-ratio": "16/9",
                    cover: "",
                    src: $setup.imageUrl
                  }, null, 8, ["src"]),
                  _createVNode(_component_v_icon, { icon: "mdi mdi-file-image-box" }),
                  ($setup.errorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString($setup.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_75
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createVNode(_component_Button, {
                  variant: "accent",
                  label: $setup.attachmentDataList.length ? 'ADD ANOTHER' : 'add',
                  isActive: $setup.uploadedImages,
                  onClick: $setup.addIssueImage,
                  class: "button",
                  block: "",
                  "aria-label": "Refresh"
                }, null, 8, ["label", "isActive", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              ($setup.attachmentDataList.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.attachmentDataList, (attachment, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "show_uploaded_details",
                          key: index
                        }, [
                          _createVNode(_component_v_img, {
                            class: "uploaded-img",
                            width: 156,
                            height: 88,
                            "aspect-ratio": "16/9",
                            cover: "",
                            src: attachment?.uploadedImages?.url
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("h5", null, _toDisplayString(attachment?.uploadedImages?.name), 1),
                            _createVNode(_component_v_btn, {
                              onClick: ($event: any) => ($setup.removeImageFromAttachments(index)),
                              variant: "text"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_82
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createVNode(_component_v_combobox, {
                              class: "selectprop_dropdown",
                              modelValue: attachment.userCategoryName,
                              "onUpdate:modelValue": ($event: any) => ((attachment.userCategoryName) = $event),
                              items: $setup.userCategory,
                              "item-title": "name",
                              "item-value": "name",
                              variant: "outlined",
                              placeholder: "Enter or select category",
                              multiple: "",
                              "menu-props": { contentClass: 'text__selector' }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                          ]),
                          _createVNode(_component_v_menu, {
                            transition: "slide-y-reverse-transition",
                            class: "slider-menu-active",
                            activator: `#menu-activator-${index}`,
                            active: true
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userCategory, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, {
                                          class: "cursor-pointer",
                                          onClick: ($event: any) => (attachment.userCategoryName = item.name)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["activator"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_84, _hoisted_86))
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_Button, {
              label: "Cancel",
              class: "button",
              onClick: $setup.onClickToggleAttachmentModal,
              variant: "secondary"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              label: "Save",
              variant: "accent",
              class: "button",
              isLoading: $setup.isLoadingOnSave,
              isActive: $setup.isAttachmentDataValid,
              onClick: $setup.onClickSaveButtonAttachmentsModal
            }, null, 8, ["isLoading", "isActive", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: $setup.isCarouselDialog,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.isCarouselDialog) = $event)),
        height: "auto",
        "max-width": "600",
        class: "issue__carousal__modal",
        "show-arrows": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            actions: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.isCarouselDialog = false)),
                class: "d-flex"
              }),
              _createVNode(_component_v_carousel, {
                "hide-delimiter-background": "",
                "show-arrows": "hover",
                modelValue: $setup.currentIndex,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.currentIndex) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_carousel_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        cover: "",
                        src: $setup.carouselImage,
                        height: "100%",
                        width: "100%"
                      }, null, 8, _hoisted_88)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    ($setup.isShowSpecialismModal)
      ? (_openBlock(), _createBlock(_component_SpecialismMultiSelectModel, {
          key: 0,
          onOnClickCloseTab: $setup.closeSpecialismModal,
          selectedSpecialism: $setup.issueSubCategoryIdForSpecialismModel,
          onOnClickSaveButtonClick: $setup.onClickSaveButtonClick,
          isLoadingForSaveService: $setup.isLoadingForSpecialismComponent
        }, null, 8, ["onOnClickCloseTab", "selectedSpecialism", "onOnClickSaveButtonClick", "isLoadingForSaveService"]))
      : _createCommentVNode("", true),
    ($setup.isShowManualInterventionModal)
      ? (_openBlock(), _createBlock(_component_ManualIntervention, {
          key: 1,
          issueDetail: $setup.issuesReviewComponent,
          onOnClickManualIntervention: $setup.onClickManualIntervention,
          isLoading: $setup.isLoading,
          onOnClickNoIntervene: $setup.onClickNoIntervene
        }, null, 8, ["issueDetail", "onOnClickManualIntervention", "isLoading", "onOnClickNoIntervene"]))
      : _createCommentVNode("", true)
  ], 64))
}